import { realBricksApi } from '../../utils/axiosInterceptors';

export const placeBidOrder = async (data, { rejectWithValue }) => {
  const { bidData, onFail = () => {}, onSuccess = () => {} } = data;
  try {
    const response = await realBricksApi.post(`/api/v1/payment/bid`, bidData);
    onSuccess()
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};

export const placeSellOrder = async (data, { rejectWithValue }) => {
  const { bidData, onFail = () => {}, onSuccess = () => {} } = data;
  try {
    const response = await realBricksApi.post(`/api/v1/payment/sell`, bidData);
    onSuccess()
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};

